define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/skillDefaultSurveySection.tmpl");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Bubble = require("ui/bubble/Bubble");
    var KpContent = require("ui.components/kpContent/kpContent");
    var SurveyModel = require("models/entities/SurveyModel");
    var SkillModel = require("models/entities/SkillModel");

    var DEFAULT_SURVEY_KP_ID = "using-forms";

    var SkillDefaultSurveySectionView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillDefaultSurveySectionView = Marionette.ItemView.extend({
            className: "default-survey-section-container",
            template: template,
            ui:{
                defaultSurveyIcon: ".default-survey-section-container .icon",
                surveyMapping: ".survey-mapping-container",
                postChatSurveyCheck: ".post-chat-survey-container .post-chat-survey-option",
                selectedPostChatSurvey: ".post-chat-survey-container .select-survey",
                offlineSurveyCheck: ".offline-survey-container .offline-survey-option",
                selectedOfflineSurvey: ".offline-survey-container .select-survey",
                agentSurveyCheck: ".agent-survey-container .agent-survey-option",
                selectedAgentSurvey: ".agent-survey-container .select-survey",
                conversationTypeLabel: ".conversation-type-label"
            },
            uiComponents: {
                postChatSurveyOption: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.postChatSurveyCheck",
                        checked: "view._isPostChatSurveyEnabled",
                        label: LE.translator.translate("LEUserManagement.skillEdit.survey.default.post.chat.label"),
                        permutation: Checkbox.PERMUTATION.C
                    },
                    events: {
                        "change": "_onPostChatSurveyChecked"
                    }
                },
                offlineSurveyOption: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.offlineSurveyCheck",
                        checked: "view._isOfflineSurveyEnabled",
                        label: LE.translator.translate("LEUserManagement.skillEdit.survey.default.offline.label"),
                        permutation: Checkbox.PERMUTATION.C
                    },
                    events: {
                        "change": "_onOfflineSurveyChecked"
                    }
                },
                agentSurveyOption: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.agentSurveyCheck",
                        checked: "view._isAgentSurveyEnabled",
                        label: LE.translator.translate("LEUserManagement.skillEdit.survey.default.agent.label"),
                        permutation: Checkbox.PERMUTATION.C
                    },
                    events: {
                        "change": "_onAgentSurveyChecked"
                    }
                },
                postChatSurveyDropdown: {
                    type: Dropdown,
                    options: {
                        placeholder: LE.translator.translate("LEUserManagement.skillEdit.survey.default.select.survey"),
                        name: "postChatSurveyDropdown",
                        container: "view.ui.selectedPostChatSurvey",
                        items: "view._getPostChatSurveyDropdownModels",
                        enabled: "view._isPostChatSurveyEnabled",
                        permutation: Dropdown.PERMUTATION.MEDIUM
                    },
                    events: {
                        "change": "_onPostChatSurveyChange"
                    }
                },
                offlineSurveyDropdown: {
                    type: Dropdown,
                    options: {
                        placeholder: LE.translator.translate("LEUserManagement.skillEdit.survey.default.select.survey"),
                        name: "offlineSurveyDropdown",
                        container: "view.ui.selectedOfflineSurvey",
                        items: "view._getOfflineSurveyDropdownModels",
                        enabled: "view._isOfflineSurveyEnabled",
                        permutation: Dropdown.PERMUTATION.MEDIUM
                    },
                    events: {
                        "change": "_onOfflineSurveyChange"
                    }
                },
                agentSurveyDropdown: {
                    type: Dropdown,
                    options: {
                        placeholder: LE.translator.translate("LEUserManagement.skillEdit.survey.default.select.survey"),
                        name: "agentSurveyDropdown",
                        container: "view.ui.selectedAgentSurvey",
                        items: "view._getAgentSurveyDropdownModels",
                        enabled: "view._isAgentSurveyEnabled",
                        permutation: Dropdown.PERMUTATION.MEDIUM
                    },
                    events: {
                        "change": "_onAgentSurveyChange"
                    }
                }
            },
            events: {
                "mouseenter @ui.defaultSurveyIcon": "_showDefaultSurveyBubble",
                "mouseleave @ui.defaultSurveyIcon": "_closeDefaultSurveyBubble"
            },
            modelEvents: {
                "change": "_onModelChange"
            },

            getModel: function() {
                return this.model;
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.model = options.model;
                this.surveyCollection = options.surveyCollection;
                this.channel = options.channel;
                this._filterSurveyCollections();
            },

            _onRender: function() {
                this._updateDefaultSurveySelection();
                this._showConversationTypeLabels();
            },

            _showConversationTypeLabels: function() {
                // hide the labels if no messaging in the account
                var isMessagingAccount = LE.sessionManager.hasAsyncMessagingFeature();
                this.ui.conversationTypeLabel.toggleClass("hide", !isMessagingAccount);
            },

            _filterSurveyCollections: function() {
                this.offlineSurveyCollection = this.surveyCollection.filterBy(SurveyModel.KEYS.TYPE, SurveyModel.VALUES.TYPE.OFFLINE, {
                    ignoreCase: true
                });
                this.postChatSurveyCollection = this.surveyCollection.filterBy(SurveyModel.KEYS.TYPE, SurveyModel.VALUES.TYPE.POST_CHAT, {
                    ignoreCase: true
                });
                this.agentSurveyCollection = this.surveyCollection.filterBy(SurveyModel.KEYS.TYPE, SurveyModel.VALUES.TYPE.AGENT, {
                    ignoreCase: true
                });
            },

            _updateDefaultSurveyPostChat: function() {
                var modelDefaultSurveyPostChatId = this.model.getDefaultSurveyPostChat();
                var isFoundSelectedSurveyPostChatInList = _.some(this._getPostChatSurveyDropdownModels().models, function(model) {
                    return model.get("key") === modelDefaultSurveyPostChatId;
                }, this);

                if (isFoundSelectedSurveyPostChatInList) {
                    this.uiComponents.postChatSurveyDropdown.setSelection(modelDefaultSurveyPostChatId);
                } else {
                    this.uiComponents.postChatSurveyOption.setCheckedState(false);
                    this.uiComponents.postChatSurveyDropdown.setEnabled(false);
                }
            },

            _updateDefaultSurveyOffline: function() {
                var modelDefaultSurveyOfflineId = this.model.getDefaultSurveyOffline();
                var isFoundSelectedSurveyOfflineInList = _.some(this._getOfflineSurveyDropdownModels().models, function(model) {
                    return model.get("key") === modelDefaultSurveyOfflineId;
                }, this);

                if (isFoundSelectedSurveyOfflineInList) {
                    this.uiComponents.offlineSurveyDropdown.setSelection(modelDefaultSurveyOfflineId);
                } else {
                    this.uiComponents.offlineSurveyOption.setCheckedState(false);
                    this.uiComponents.offlineSurveyDropdown.setEnabled(false);
                }
            },

            _updateDefaultSurveyAgent: function() {
                var modelDefaultSurveyAgentId = this.model.getDefaultSurveyAgent();
                var isFoundSelectedSurveyAgentInList = _.some(this._getAgentSurveyDropdownModels().models, function(model) {
                    return model.get("key") === modelDefaultSurveyAgentId;
                }, this);

                if (isFoundSelectedSurveyAgentInList) {
                    this.uiComponents.agentSurveyDropdown.setSelection(modelDefaultSurveyAgentId);
                } else {
                    this.uiComponents.agentSurveyOption.setCheckedState(false);
                    this.uiComponents.agentSurveyDropdown.setEnabled(false);
                }
            },

            _updateDefaultSurveySelection: function() {
                this._updateDefaultSurveyPostChat();
                this._updateDefaultSurveyOffline();
                this._updateDefaultSurveyAgent();
            },

            _getPostChatSurveyDropdownModels: function () {
                return this._getSurveyDropDownModels(this.postChatSurveyCollection);
            },

            _getOfflineSurveyDropdownModels: function () {
                return this._getSurveyDropDownModels(this.offlineSurveyCollection);
            },

            _getAgentSurveyDropdownModels: function () {
                return this._getSurveyDropDownModels(this.agentSurveyCollection);
            },

            _getSurveyDropDownModels: function (collection) {
                var dropdownModels = [];
                dropdownModels = _.map(collection.models, function (surveyModel) {
                    return {
                        key: surveyModel.id,
                        value: surveyModel.getSurveyName()
                    };
                });
                return new Dropdown.Collection(dropdownModels);
            },

            _isPostChatSurveyEnabled: function() {
                return this.model.getDefaultSurveyPostChat() !== SkillModel.EMPTY_VALUE;
            },

            _isOfflineSurveyEnabled: function() {
                return this.model.getDefaultSurveyOffline() !== SkillModel.EMPTY_VALUE;
            },

            _isAgentSurveyEnabled: function() {
                return this.model.getDefaultSurveyAgent() !== SkillModel.EMPTY_VALUE;
            },

            _onPostChatSurveyChecked: function(event, itemView, checked) {
                //When Post-Chat survey checkbox is enabled, so is the corresponding dropdown
                this.uiComponents.postChatSurveyDropdown.setEnabled(checked);
                if (checked) {
                    var selectedPostChatSurveyValue = this.uiComponents.postChatSurveyDropdown.getValue();
                    if (selectedPostChatSurveyValue !== SkillModel.EMPTY_VALUE) { //If a value was chosen in the dropdown and later on unchecked and checked again
                        this.channel.trigger("skill:change:defaultPostChatSurvey", selectedPostChatSurveyValue);
                    }
                } else if (this.model.getDefaultSurveyPostChat() !== SkillModel.EMPTY_VALUE) { //Only if unchecked and already exists value on the model, it should be changed, otherwise UI indication only
                    this.channel.trigger("skill:change:postChatSurveyCheckbox", checked);
                }
                this.channel.trigger("skill:change:surveyChecked", {valueIsChanged: true});
            },

            _onOfflineSurveyChecked: function(event, itemView, checked) {
                //When Offline survey checkbox is enabled, so is the corresponding dropdown
                this.uiComponents.offlineSurveyDropdown.setEnabled(checked);
                if (checked) {
                    var selectedOfflineSurveyValue = this.uiComponents.offlineSurveyDropdown.getValue();
                    if (selectedOfflineSurveyValue !== SkillModel.EMPTY_VALUE) { //If a value was chosen in the dropdown and later on unchecked and checked again
                        this.channel.trigger("skill:change:defaultOfflineSurvey", selectedOfflineSurveyValue);
                    }
                } else if (this.model.getDefaultSurveyOffline() !== SkillModel.EMPTY_VALUE) { //Only if unchecked and already exists value on the model, it should be changed, otherwise UI indication only
                    this.channel.trigger("skill:change:offlineSurveyCheckbox", checked);
                }
                this.channel.trigger("skill:change:surveyChecked", {valueIsChanged: true});
            },

            _onAgentSurveyChecked: function(event, itemView, checked) {
                //When Agent survey checkbox is enabled, so is the corresponding dropdown
                this.uiComponents.agentSurveyDropdown.setEnabled(checked);
                if (checked) {
                    var selectedAgentSurveyValue = this.uiComponents.agentSurveyDropdown.getValue();
                    if (selectedAgentSurveyValue !== SkillModel.EMPTY_VALUE) { //If a value was chosen in the dropdown and later on unchecked and checked again
                        this.channel.trigger("skill:change:defaultAgentSurvey", selectedAgentSurveyValue);
                    }
                } else if (this.model.getDefaultSurveyAgent() !== SkillModel.EMPTY_VALUE) { //Only if unchecked and already exists value on the model, it should be changed, otherwise UI indication only
                    this.channel.trigger("skill:change:agentSurveyCheckbox", checked);
                }
                this.channel.trigger("skill:change:surveyChecked", {valueIsChanged: true});
            },

            _onPostChatSurveyChange: function(componentId, eventName, obj) {
                this.channel.trigger("skill:change:defaultPostChatSurvey", obj.selectedKey);
            },

            _onOfflineSurveyChange: function(componentId, eventName, obj) {
                this.channel.trigger("skill:change:defaultOfflineSurvey", obj.selectedKey);
            },

            _onAgentSurveyChange: function(componentId, eventName, obj) {
                this.channel.trigger("skill:change:defaultAgentSurvey", obj.selectedKey);
            },

            _showDefaultSurveyBubble: function() {
                this._closeDefaultSurveyBubble(null, true);
                this.uiComponents.host$.createAndRender("kpContent", {
                    type : KpContent,
                    options : {
                        content: LE.translator.translate("LEUserManagement.skillEdit.survey.default.tooltip"),
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: DEFAULT_SURVEY_KP_ID
                    },
                    events: {
                        "click": "_closeDefaultSurveyBubble"
                    }
                });
                this.uiComponents.host$.createAndRender("defaultSurveyBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.defaultSurveyIcon,
                        contentView: this.uiComponents.kpContent,
                        showCloseButton: false,
                        position: Bubble.POSITION.RIGHT
                    }
                });
            },

            _closeDefaultSurveyBubble: function(event, force) {
                if (this.uiComponents.defaultSurveyBubble) {
                    this.uiComponents.defaultSurveyBubble.close(force);
                }
            },

            validateSaveEnabled: function() {
                var isSaveEnabled = true;
                if (this.uiComponents.postChatSurveyOption && this.uiComponents.offlineSurveyOption && this.uiComponents.agentSurveyOption) {
                    isSaveEnabled = this._isDefaultPostChatSurveySaveEnabled() && this._isDefaultOfflineSurveySaveEnabled() && this._isDefaultAgentSurveySaveEnabled();
                }
                return isSaveEnabled;
            },

            _isDefaultPostChatSurveySaveEnabled: function() {
                return ((this.uiComponents.postChatSurveyOption.isChecked() && (this.model.getDefaultSurveyPostChat() !== SkillModel.EMPTY_VALUE)) || !this.uiComponents.postChatSurveyOption.isChecked());
            },

            _isDefaultOfflineSurveySaveEnabled: function() {
                return ((this.uiComponents.offlineSurveyOption.isChecked() && (this.model.getDefaultSurveyOffline() !== SkillModel.EMPTY_VALUE)) || !this.uiComponents.offlineSurveyOption.isChecked());
            },

            _isDefaultAgentSurveySaveEnabled: function() {
                return ((this.uiComponents.agentSurveyOption.isChecked() && (this.model.getDefaultSurveyAgent() !== SkillModel.EMPTY_VALUE)) || !this.uiComponents.agentSurveyOption.isChecked());
            },

            _onModelChange: function() {
                this.channel.trigger("skill:model:surveyChanged", {valueIsChanged: true});
            }
            //</editor-fold>
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillDefaultSurveySectionView;

});
